import * as React from 'react';
import { memo, useCallback } from 'react';
import { useIntl } from 'react-intl';

import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { Button, Typography } from '@bolteu/kalep-react';

import { SolidColors } from '../../../../../common/all/styles/bolt-uikit-colors';

export interface CancelOfflinePeriodConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const CancelOfflinePeriodConfirmationDialog: React.FC<CancelOfflinePeriodConfirmationDialogProps> =
  memo(({ isOpen, onClose, onConfirm }) => {
    const { formatMessage } = useIntl();
    const onRequestClose = useCallback(() => {
      onClose();
    }, [onClose]);
    return (
      <Box>
        <Dialog fullScreen={false} maxWidth={false} open={isOpen} onClose={onRequestClose}>
          <DialogTitle>
            <Box>
              <Typography variant="title-primary">
                {formatMessage({
                  id: 'offlinePeriods.cancelConfirmationDialogTitle',
                })}
              </Typography>
            </Box>
          </DialogTitle>
          <DialogContent />
          <DialogActions sx={{ borderTop: `1px solid ${SolidColors.neutral300}` }}>
            <Button autoFocus variant="secondary" onClick={onRequestClose}>
              {formatMessage({ id: 'buttons.cancel' })}
            </Button>
            <Button size="md" onClick={onConfirm}>
              {formatMessage({ id: 'buttons.confirm' })}
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    );
  });
